import {} from "react-admin";
import {
  Datagrid,
  List,
  TextField,
  AutocompleteInput,
  ReferenceInput,
} from "react-admin";

// const Aside = () => (
//   <div style={{ width: 200, margin: "1em" }}>
//     <h3>123</h3>
//   </div>
// );
const ListFilters = [
  <ReferenceInput source="name" reference="doctors" alwaysOn>
    <AutocompleteInput
      filterToQuery={(text) => ({ name: text })}
      helperText={false}
      optionText={"name"}
    />
  </ReferenceInput>,
];

export const DoctorList = (props) => {
  return (
    <List
      {...props}
      exporter={false}
      filters={ListFilters}
      // aside={<Aside />}
    >
      <Datagrid rowClick="show">
        <TextField source="name" />
        <TextField source="vicinity" />
      </Datagrid>
    </List>
  );
};
